import React, { useState, useEffect } from 'react'
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import { TextField } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import * as Yup from "yup";
import { useFormik } from 'formik';
import { useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import { createStakeholder, updateStakeholder } from '../../../api/casp/stakeholder';
import { stakeholderCommunicationState, stakeholderGroup } from '../../../constants/StakeholderType';
import { Action } from '../../../constants/Common';
import { withTranslation } from 'react-i18next';
import Drawer from "@mui/material/Drawer";
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiDialog-paper': {
        width: '35%', // Adjust the width here as needed, like '500px'
        maxWidth: 'none', // This will override the max-width set by Material-UI
    },

}));
const AddStakeholders = ({ open, onClose, action, stakeholderDetails, refetch, t }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [group, setGroup] = useState(false);
    const [type, setType] = useState(false)
    const stakeholdersinitialObject = {
        name: "",
        email: "",
        communication_state: "",
        group: "",
        // type: "",
        // customType: "",
        contactNo: "",
    }
    const [showCustomType, setShowCustomType] = useState(false)
    const [stakeholderObject, setStakeholderObject] = useState({ ...stakeholdersinitialObject })
    const { project } = useParams();
    const formValidation = Yup.object().shape({
        name: Yup.string()
            .strict(true)
            .trim(t('Must not include leading and trailing spaces'))
            .max(250, t("Too Long!"))
            .required(t("Please enter name")),
        email: Yup.string()
            .strict(true)
            .trim(t('Must not include leading and trailing spaces'))
            .email(t('Invalid email address'))
            .required(t("Please enter email")),
        // entity: Yup.string()
        //     .strict(true)
        //     .trim(t('Must not include leading and trailing spaces'))
        //     .max(250, t("Too Long!"))
        //     .required(t("Please enter entity")),
        group: Yup.string()
            .required(t("Please select group"))
            .test('is-valid-group', 'Invalid group', value => stakeholderGroup.includes(value)),
        communication_state: Yup.string()
            .required(t("Please select state of communication"))
            .test('is-valid-type', 'Invalid type', value => stakeholderCommunicationState.includes(value)),
        // customType: Yup.string()
        //     .when('type', {
        //         is: 'Others',
        //         then: Yup.string()
        //             .strict(true)
        //             .trim(t('Must not include leading and trailing spaces'))
        //             .required(t('Please enter custom type')),
        //         otherwise: Yup.string()
        //     }),
        contactNo: Yup.string()
            .strict(true)
            .trim(t('Must not include leading and trailing spaces'))
            .matches(/^\+?[0-9]([0-9]|(-(?!-)))*[0-9]$/, t('Contact no is not valid')),
    })

    const formik = useFormik({
        initialValues: {
            ...stakeholderObject
        },
        validationSchema: formValidation,
        validateOnMount: true,
        onSubmit: (value) => {
            action === Action.EDIT ?
                handleUpdate() :
                handleCreate()
        }
    })
    const handleCreate = async () => {
        try {
            setIsLoading(true)
            const payload = {
                projectId: parseInt(project),
                name: formik.values.name,
                email: formik.values.email,
                communicationState: formik.values.communication_state,
                group: formik.values.group,
                // type: formik.values.type,
                // ...(formik.values.type === 'Others' && {
                //     customType: formik.values.customType,
                // }),
                ...(formik.values.contactNo && {
                    contactNo: formik.values.contactNo,
                })
            }
            const response = await createStakeholder(payload)
            refetch()
            toast.success(response.data.message);
            handleClose();
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        } finally {
            setIsLoading(false);
        }
    }
    const handleUpdate = async () => {
        try {
            setIsLoading(true)
            const payload = {
                projectId: parseInt(project),
                name: formik.values.name,
                email: formik.values.email,
                communicationState: formik.values.communication_state,
                group: formik.values.group,
                // type: formik.values.type,
                // ...(formik.values.type === 'Others' && {
                //     customType: formik.values.customType,
                // }),
                ...(formik.values.contactNo && {
                    contactNo: formik.values.contactNo,
                })
            }
            const response = await updateStakeholder(stakeholderDetails.id, payload)
            refetch()
            toast.success(response.data.message);
            handleClose();
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        } finally {
            setIsLoading(false);
        }
    }
    const handleClose = (_, reason) => {
        if (reason === "backdropClick") {
            return;
        }
        setIsLoading(false);
        onClose(); // Call onClose to close the modal
        formik.resetForm({ ...stakeholdersinitialObject });
    };

    const handleGroupChange = (event) => {
        setGroup(event.target.value);
        formik.setFieldValue("group", event.target.value ? event.target.value : "");
    }

    // const handleTypeChange = (event) => {
    //     if (event.target.value === 'Others') {
    //         setShowCustomType(true)
    //     } else {
    //         setShowCustomType(false)
    //     }
    //     setType(event.target.value);
    //     formik.setFieldValue("type", event.target.value ? event.target.value : "");
    // }

    useEffect(() => {
        const stakeholderObject = {
            name: stakeholderDetails.name,
            email: stakeholderDetails.email,
            group: stakeholderDetails.group,
            communication_state: stakeholderDetails?.communicationState,
            contactNo: stakeholderDetails.contactNo ?? '',
        }
        if (action === Action.EDIT) {
            formik.setValues({ ...stakeholderObject })
            setStakeholderObject(stakeholderObject)
            // if (stakeholderDetails.type === 'Others') {
            //     setShowCustomType(true)
            // } else {
            //     setShowCustomType(false)
            // }
        }
    }, [action, stakeholderDetails])
    return (
        <React.Fragment>
            {/* <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}

            > */}
            <Drawer
                anchor="right"
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: { width: "580px" },
                }}
                className="projectListDrawer addRiskDrawer"
            >
                <form className="p-3" onSubmit={(e) => {
                    e.preventDefault()
                    formik.handleSubmit(e)
                }}>
                    <h5>{action === Action.EDIT ? t(`Update`) : t(`Add`)} {t("Client")}</h5>
                    <CloseIcon className="crossIcon" onClick={handleClose} />

                    <div className="innerTbContent">
                        <div className="row">
                            <div className="col-sm-12 mb-3">
                                <TextField
                                    fullWidth
                                    id="outlined-basic"
                                    label={t("Name")}
                                    className=""
                                    name="name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    required
                                />
                                {formik.touched.name && formik.errors.name && (
                                    <span className="text-danger d-block">{formik.errors.name}</span>
                                )}
                            </div>
                            <div className="col-sm-12 mb-3">
                                <TextField
                                    fullWidth
                                    id="outlined-basic"
                                    label={t("Email")}
                                    className=""
                                    name="email"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    required
                                />
                                {formik.touched.email && formik.errors.email && (
                                    <span className="text-danger d-block">{formik.errors.email}</span>
                                )}
                            </div>
                            <div className="col-sm-12 mb-3">
                                <Box sx={{ minWidth: 150 }}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">{t("State of Communication")} *</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label={t("State of Communication")}
                                            placeholder='State of Communication'
                                            name="communication_state"
                                            value={formik.values.communication_state}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            required
                                            size='small'
                                            fullWidth
                                        >
                                            {
                                                stakeholderCommunicationState.map((type, key) => (<MenuItem key={key} value={type}>{type}</MenuItem>))
                                            }
                                        </Select>

                                        {formik.touched.communication_state && formik.errors.communication_state && (
                                            <span className="text-danger d-block">{formik.errors.communication_state}</span>
                                        )}
                                    </FormControl>
                                </Box>
                            </div>
                            {/* <div className="col-sm-6 mb-3">
                                <TextField
                                    fullWidth
                                    id="outlined-basic"
                                    label={t("State of Communication")}
                                    className=""
                                    name="communication_state"
                                    value={formik.values.communication_state}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    required
                                />
                                {formik.touched.communication_state && formik.errors.communication_state && (
                                    <span className="text-danger d-block">{formik.errors.communication_state}</span>
                                )}
                            </div> */}
                            <div className="col-sm-6 mb-3">
                                <Box sx={{ minWidth: 150 }}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">{t("Group")} *</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={formik.values.group}
                                            label={t("Group")}
                                            placeholder='Group'
                                            onChange={handleGroupChange}
                                            required
                                            size='small'
                                            fullWidth
                                            onBlur={() => {
                                                if (!formik.touched?.group) {
                                                    formik.setFieldTouched("group", true, false);
                                                }
                                            }}
                                        >
                                            {
                                                stakeholderGroup.map((type, key) => (<MenuItem key={key} value={type}>{type}</MenuItem>))
                                            }
                                        </Select>

                                        {formik.touched.group && formik.errors.group && (
                                            <span className="text-danger d-block">{formik.errors.group}</span>
                                        )}
                                    </FormControl>
                                </Box>
                            </div>
                            {/* <div className='col-sm-6 mb-3'>
                                <Box sx={{ minWidth: 150 }}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">{t("Type")} *</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={formik.values.type}
                                            label={t("Type")}
                                            onChange={handleTypeChange}
                                            required
                                            onBlur={() => {
                                                if (!formik.touched?.type) {
                                                    formik.setFieldTouched("type", true, false);
                                                }
                                            }}
                                        >
                                            {
                                                stakeholderType.map((type, key) => (<MenuItem key={key} value={type}>{type}</MenuItem>))
                                            }
                                        </Select>
                                    </FormControl>
                                    {formik.touched.type && formik.errors.type && (
                                        <span className="text-danger d-block">{formik.errors.type}</span>
                                    )}
                                </Box>
                            </div>
                            {
                                showCustomType &&
                                <div className='col-sm-6 mb-3'>
                                    <TextField
                                        fullWidth
                                        id="outlined-basic"
                                        label="custom Type"

                                        name="customType"
                                        value={formik.values.customType}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.customType && formik.errors.customType && (
                                        <span className="text-danger d-block">{formik.errors.customType}</span>
                                    )}

                                </div>
                            } */}
                            <div className="col-sm-6 mb-3">
                                <TextField
                                    fullWidth
                                    id="outlined-basic"
                                    label={t("Contact Number")}
                                    className=""
                                    name="contactNo"
                                    value={formik.values.contactNo}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}

                                />
                                {formik.touched.contactNo && formik.errors.contactNo && (
                                    <span className="text-danger d-block">{formik.errors.contactNo}</span>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="plsubmitButton">
                        <Button
                            variant="contained"
                            //color="primary"
                            className={`${isLoading || Object.keys(formik.errors).filter((e) => !['solutionName', 'solutionDescription'].includes(e)).length > 0 ?
                                'submitBtn btn addNew_ProjectBtn' : 'submitBtn btn addNew_ProjectBtn'} mx-1`}
                            autoFocus
                            disabled={isLoading || !formik.isValid}
                            type="submit"
                        >{action === Action.EDIT ? t(`Update`) : t(`Add`)}</Button>
                    </div>

                </form>
            </Drawer>
        </React.Fragment >
    );
}

export default withTranslation()(AddStakeholders)